var React = require('react');

function IcV (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.81112 0.191791C10.0642 0.446409 10.0629 0.857964 9.80831 1.11103L3.60821 7.26101C3.35414 7.51353 2.94367 7.5129 2.69038 7.25961L0.190381 4.75961C-0.0634602 4.50577 -0.0634602 4.09421 0.190381 3.84037C0.444221 3.58653 0.855779 3.58653 1.10962 3.84037L3.15141 5.88215L8.89189 0.188974C9.14651 -0.0640875 9.55806 -0.0628262 9.81112 0.191791Z","fill":"currentColor"}));
}

IcV.defaultProps = {"id":"ic-v","viewBox":"0 0 13 9","fill":"none"};

module.exports = IcV;

IcV.default = IcV;
